import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Icons from "../../../utils/components/icons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  OrganisationContext,
  ReportsDownloadUpdate,
  UserContext,
} from "../../../layouts/MainLayout";
import moment from "moment";
import { extractVersion, formatAMPM, formatDate } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import EmptyScreen from "../../../utils/components/common/EmptyScreen/EmptyScreen";
import MultiSelectDropdown from "../../../utils/components/common/multiSelectDropdown/MultiSelectDropdown";

/**Style**/
import "../ReportDetails.scss";
import { getSiteByTenantId } from "../../../services/SitesService";
import classNames from "classnames";
import { getLocationAndHierarchyDetails } from "../../../services/LocationService";
import { getLatestFirmwareUpdateDetails } from "../../../services/OTAService";
import { 
  generateDeviceUpdateCsvReport,
  getDeviceUpdateListData,
} from "../../../services/ReportService";
import OTAUpdates from "../../deviceView/ota/OTAUpdates";
import { getAllDeviceList } from "../../../services/DeviceService";
import LoadingSpinner from "../../../utils/components/common/loadingSpinner/LoadingSpinner";
import Pagination from "../../../utils/components/common/pagination";
import ModalComponent from "../../../utils/components/common/modalComponent/ModalComponent";

const DeviceUpdateList = () => {
  const { t } = useTranslation("reports");
  const [modelFilterVal, setModelFilterVal] = useState([]);
  const [systemStatus, setSystemStatus] = useState([]);
  const [siteDetails, setSiteDetails] = useState([]);
  const [siteListDetails, setSiteListDetails] = useState([]);
  const [siteVal, setSiteVal] = useState([]);
  const [versionDetails, setVersionDetails] = useState([]);
  const [versionListOption, setVersionListOption] = useState([]);
  const [selectedVersionData, setSelectedVersionData] = useState([]);
  const [updateListData, setUpdateListData] = useState([]);

  const [deviceData, setDeviceData] = useState();
  const [selectedDevice, setSelectedDevice] = useState();
  const [selectedDeviceData, setSelectedDeviceData] = useState();

  const [isAllSites, setIsAllSites] = useState(false);
  const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
  const [isOTAModalOpen, setIsOTAModalOpen] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [isLocationFilterApplied, setIsLocationFilterApplied] = useState(false);
  const [transformedSortConfigs, setTransformedSortConfigs] = useState();

  const [isLoading, setIsLoading] = useState(false);
  const [isDeviceDetailsLoading, setIsDeviceDetailsLoading] = useState(false);
  const [isDeviceDetailsErr, setIsDeviceDetailsErr] = useState(false);
  const [refreshTime, setRefreshTime] = useState(new Date());

  const [pageTotalCount, setPageTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [previousDeviceCurrentLocation, setPreviousDeviceCurrentLocation] = useState([]);
  const [previousSelectedLocation, setPreviousSelectedLocation] = useState([]);
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [isClearClicked, setIsClearClicked] = useState(false);

  const [deviceCurrentLocation, setDeviceCurrentLocation] = useState("");
  const [displayLocation, setDisplayLocation] = useState("");
  const [selectedLocation, setsetSelectedLocationLevel] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [allSelectedLevels, setAllSelectedLevels] = useState([]);
  const [assignChecker, setAssignChecker] = useState(false);
  const [matchingPKs, setMatchingPKs] = useState([]);
  const [matchingSKs, setMatchingSKs] = useState([]);
  const [expandedItem, setExpandedItem] = useState([]);
  const [isFloorDropdownOpen, setIsFloorDropdownOpen] = useState(false);
  const [isRoomDropdownOpen, setIsRoomDropdownOpen] = useState(false);
  const [locationDetailsList, setLocationDetailsList] = useState([]);
  const [currentActiveLocation, setCurrentActiveLocation] = useState([]);

  const dropdownRef = useRef(null);

  // Initial state with default sorting for Device Name
  const [sortConfigs, setSortConfigs] = useState([
    { key: "deviceName", direction: "ascending" },
  ]);

  /**Contexts */
  const { reportUpdateStatus } = useContext(ReportsDownloadUpdate);

  /**Context* section starts*/
  const {userCognitoData, userData } =
    useContext(UserContext);
  const { siteData, orgData } = useContext(OrganisationContext);
  /**Context* section ends*/

  /**Location related */
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location?.pathname?.split("/")[2] || "";

  /**Go back to device view**/
  const goBack = useCallback(() => {
    navigate("/reports");
  }, [navigate]);

  const modelFilterOption = useMemo(() => {
    const modelList = [
      { name: t("reportFilter.chorusUpdateDeviceList.aplha3+"), id: "ALPHA3" },
    ];
    return modelList;
  }, [t]);

  const systemStatusOption = [
    {
      name: t("reportFilter.chorusUpdateDeviceList.updateAvailable"),
      id: "UpdateAvailable",
    },
    {
      name: t("reportFilter.chorusUpdateDeviceList.updateInProgress"),
      id: "InProgress",
    },
    {
      name: t("reportFilter.chorusUpdateDeviceList.systemUpToDate"),
      id: "UpToDate",
    },
  ];

  const getAllSiteDetails = useCallback(async () => {
    const queryParams = {
      tenantId: userData.OrganizationID,
      siteStatus: "All",
      sort: [
        {
          SiteName: "ASC",
        },
      ],
    };
    getSiteByTenantId(queryParams)
      .then((response) => {
        setSiteDetails(response.data?.siteListDetails);
      })
      .catch((error) => {});
  }, [userData]);

  useEffect(() => {
    getAllSiteDetails();
  }, [getAllSiteDetails, userData]);

  useEffect(() => {
    const siteArray = [];

    if (siteDetails?.length > 0) {
      siteDetails.map((item) => {
        const { SiteName, SiteId } = item;
        siteArray.push({ name: SiteName, id: SiteId });
      });
    }

    setSiteListDetails(siteArray);
  }, [siteDetails]);

  // const updateSiteVal = useCallback((filterList) => {
  //   const siteId = filterList.map((data) => data.id);
  //   setSiteVal(siteId);
  // }, []);

  const updateModeFilterVal = useCallback((filterList = []) => {
    const modelIds = filterList.map((data) => data.id);
    setModelFilterVal(modelIds);
  }, []);

  const updateSystemStatus = useCallback((filterList = []) => {
    const systemData = filterList.map((data) => data.id);
    setSystemStatus(systemData);
  }, []);

  const updateVersionList = useCallback((filterList = []) => {
    const versionData = filterList.map((data) => data.id);
    setSelectedVersionData(versionData);
  }, []);
  /**Callback functions for filter dropdowns ends**/

  // location Filter Starts

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLocationDropdownOpen(false);

        if(isClearClicked && !isApplyClicked){
          setDeviceCurrentLocation(previousDeviceCurrentLocation);
          setsetSelectedLocationLevel(previousSelectedLocation);
        }

      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isApplyClicked, isClearClicked, previousDeviceCurrentLocation, previousSelectedLocation]);

  const updateSelectedDeviceLocation = () => {
    if (deviceCurrentLocation.length) {
      const updatedLocation = deviceCurrentLocation.replaceAll("#", ", ");
      setDisplayLocation(updatedLocation);
    } else {
      setDisplayLocation("");
    }
  };

  // Function to handle the Clear button click
  const updateClearSelectedLocation = () => {
    // Save the current values before clearing them
    setPreviousDeviceCurrentLocation(deviceCurrentLocation);
    setPreviousSelectedLocation(selectedLocation);

    // Clear the current values
    setDeviceCurrentLocation([]);
    setsetSelectedLocationLevel([]);
    
    setIsClearClicked(true);
    setIsApplyClicked(false);

  };

    const handleSelectLocationLevel = (level, address, selectedItemsLevels) => {
    setDeviceCurrentLocation(address);
    setsetSelectedLocationLevel([]);
    setAllSelectedLevels(selectedItemsLevels); // To Store PKs of the Higher Heirarchy Levels

    //To De-Select Already Select Locations
    if (selectedLocation?.includes(level.PK)) {
      let updatedLocation = deviceCurrentLocation;

      if (level.Type === "Level1") {
        //To delete the entire full string for Level1
        updatedLocation = "";
      } else if (level.Type === "Level2") {
        //To delete all the Characters after the first # for Level2
        updatedLocation = deviceCurrentLocation.substring(
          0,
          deviceCurrentLocation.indexOf("#")
        );
      } else {
        //To delete all the Characters after the last # for Level3
        updatedLocation = deviceCurrentLocation.substring(
          0,
          deviceCurrentLocation.lastIndexOf("#")
        );
      }
      setDeviceCurrentLocation(updatedLocation);
      setsetSelectedLocationLevel((prevSelected) =>
        prevSelected.filter((selectedPK) => selectedPK !== level.PK)
      );
    } else {
      setsetSelectedLocationLevel((prevSelected) => [...prevSelected, level.PK]);
    }
    setAssignChecker(false);
    // setIsClearClicked(true);
  };

  const expandLocationLevel = (e, sk, defaultSelected) => {
    e.stopPropagation();

    const updatedExpandedItems = [];

    if (defaultSelected) {
      matchingSKs.forEach((matchingSK) => {
        if (sk.includes(matchingSK)) {
          updatedExpandedItems.push(matchingSK);
        }
      });
      setExpandedItem(updatedExpandedItems);
    } else {
      setExpandedItem(sk);
    }
  };

  // To Show the Entire Heirarchy as Highlighted
  useEffect(() => {
    if (allSelectedLevels) {
      // To Add the Higher Selected Levels in the selectedLocation Array
      const updatedSelectedLocation = [
        ...allSelectedLevels,
        ...selectedLocation,
      ];
      setsetSelectedLocationLevel(updatedSelectedLocation);
    }
  }, [allSelectedLevels]);

  useEffect(() => {
    // To implement the Collapse functionality on De-Selection of the Locations
    if (selectedLocation) {
      setExpandedItem(selectedLocation);
    }
  }, [selectedLocation]);

  // To Handle the Default Active Styling and Expanded Feature of Previously Selected Locations on Page Load
  useEffect(() => {
    const selectedPKs = []; // For Storing the Expanded Item's SKs
    const selectedSKs = []; // For Storing the Expanded Item's PKs

    if (locationDetailsList) {
      locationDetailsList.forEach((item) => {
        if (currentActiveLocation.includes(item.LocationName)) {
          selectedPKs.push(item.PK);
          selectedSKs.push(item.SK);
        }

        if (item.Level2) {
          item.Level2.forEach((Level2Item) => {
            if (currentActiveLocation.includes(Level2Item.LocationName)) {
              selectedPKs.push(Level2Item.PK);
              selectedSKs.push(Level2Item.SK);
            }

            if (Level2Item.Level3) {
              Level2Item.Level3.forEach((level3Item) => {
                if (currentActiveLocation.includes(level3Item.LocationName)) {
                  selectedPKs.push(level3Item.PK);
                  selectedSKs.push(level3Item.SK);
                }
              });
            }
          });
        }
      });

      setMatchingPKs(selectedPKs);
      setMatchingSKs(selectedPKs);
    }
  }, [locationDetailsList, isLocationDropdownOpen, currentActiveLocation]);

  // API Calls
  const getAllLocationHierarchyDetails  = useCallback(() => {
    const queryParams = {
      organizationId: userData?.OrganizationID,
      locationHierarchy: userData?.OrganizationID + "#" + siteData.id,
      requestedByUserId: userCognitoData.username,
      getLocationDeletableStatus: true,
    };
    getLocationAndHierarchyDetails(queryParams)
      .then((resp) => {
        if (resp?.data?.Items?.Level1 && resp.data.Items.Level1.length > 0) {
          setLocationData(resp.data.Items);
        }

        if (resp) {
          setLocationDetailsList(resp?.data?.Items?.Level1);
        }
      })
      .catch((error) => {});
  }, [siteData.id, userCognitoData.username, userData?.OrganizationID]);

  const generateSortPayload = useCallback(() => {
    const sortPayload = sortConfigs.map((config) => ({
      [config.key]: config.direction === "ascending" ? "ASC" : "DESC",
    }));

    // sortPayload.unshift({ tenant: "ASC" }, { site: "ASC" });

    return sortPayload;
  }, [sortConfigs]);

  const ItemPerPage = 10;

  const getDeviceUpdateListDetails = useCallback(() => {
    let selectedPayloadLoction = "";

    if (selectedLocation.length) {
      selectedPayloadLoction = selectedLocation[selectedLocation.length - 1];
    }

    const queryParams = {
      requestedUserId: userCognitoData.username,

      filters: {
        tenant: [orgData?.TenantId],
        site: [siteData.id],
        model: modelFilterVal,
        version: selectedVersionData,
        otaStatus: systemStatus,
      },
      sort: generateSortPayload(),
      size: 10,
      pageNo: currentPage,
    };

    queryParams.filters.deviceLocationHierarchy = selectedPayloadLoction? selectedPayloadLoction : "";

    setIsDeviceDetailsLoading(true);

    getDeviceUpdateListData(queryParams)
      .then((resp) => {
        setUpdateListData(resp?.data?.items);
        setRefreshTime(new Date());
        setPageTotalCount(Math.ceil(resp?.data?.totalCount / ItemPerPage));
        setIsDeviceDetailsLoading(false);
      })
      .catch((error) => {
        setIsDeviceDetailsErr(false);
      });
  }, [currentPage, generateSortPayload, isLocationFilterApplied, modelFilterVal, orgData?.TenantId, selectedVersionData, siteData.id, systemStatus, userCognitoData.username]);

  const getVersionDetails = useCallback(async () => {
    try {
      const queryParam = {
        requestedUserId: userCognitoData?.username,
        size: 10000
      };
      const versionData = await getLatestFirmwareUpdateDetails(queryParam);

      setVersionDetails(versionData?.data?.items || []);
    } catch (e) {}
  }, [userCognitoData?.username]);

  useEffect(() => {
    let versionData = [];

    if (versionDetails.length) {
      versionDetails.forEach((item) => {

        let versionNo = item.releaseVersion;
        let extractedVersionList = extractVersion(versionNo);

        versionData.push({
          name: extractedVersionList,
          id: extractedVersionList,
        });
      });
    }

    setVersionListOption(versionData);
  }, [versionDetails]);

  useEffect(() => {
    if (userData?.OrganizationID && siteData?.id && userCognitoData?.username) {
      getAllLocationHierarchyDetails ();
      getVersionDetails();
      getDeviceUpdateListDetails();
    }
  }, [
    userCognitoData,
    siteData,
    userData,
    getAllLocationHierarchyDetails ,
    getDeviceUpdateListDetails,
    getVersionDetails,
  ]);

  const emptyMsg = useMemo(() => {
    if (isDeviceDetailsErr) return t("errMsg1");

    if (!isLoading && !updateListData?.length) return t("no-result");

    return "";
  }, [isDeviceDetailsErr, t, isLoading, updateListData?.length]);

  const getDeviceList = useCallback(
    (isAutoRefresh = false) => {
      const tenantId = siteData.id;

      const queryParams = {
        tenantId: tenantId,
        getSchedulerStatus: true,
        sort: [{ DeviceName: "asc" }],
        userTimezone: moment.tz.guess(),
      };
      getAllDeviceList(queryParams)
        .then((response) => {
          setDeviceData(response?.data?.Items);
        })
        .catch((error) => {});
    },
    [siteData.id]
  );

  useEffect(() => {
    getDeviceList();
  }, [getDeviceList]);

  useEffect(() => {
    let data;

    if (selectedDevice) {
      deviceData.forEach((item) => {
        if (item.deviceUUIDFromTelemetry === selectedDevice) {
          data = item;
        }
      });
    }

    setSelectedDeviceData(data);
  }, [deviceData, selectedDevice]);

  // sorting
  const requestSort = (key, direction) => {
    const existingConfig = sortConfigs.find((config) => config.key === key);
    let newSortConfig;

    // Determine the next sorting state
    if (!existingConfig) {
      newSortConfig = { key, direction: "ascending" };
    } else if (existingConfig.direction === "ascending") {
      newSortConfig = { key, direction: "descending" };
    } else if (existingConfig.direction === "descending") {
      newSortConfig = null;
    }

    const newSortConfigs = newSortConfig
      ? [newSortConfig, ...sortConfigs.filter((config) => config.key !== key)]
      : sortConfigs.filter((config) => config.key !== key);

    setSortConfigs(newSortConfigs);
  };

  function transformSortConfigs(sortConfigs) {
    const result = {};
    if (sortConfigs.length) {
      sortConfigs.forEach((config) => {
        result[config.key] =
          config.direction.charAt(0).toUpperCase() + config.direction.slice(1);
      });
    }
    setTransformedSortConfigs(result);
  }

  useEffect(() => {
    transformSortConfigs(sortConfigs);
  }, [sortConfigs]);

  const getSortClass = (key, direction) => {
    const config = sortConfigs.find((config) => config.key === key);
    return config && config.direction === direction
      ? "sort-icon active"
      : "sort-icon";
  };

  function extractLocationDetails(dataString) {
    const firstHashIndex = dataString.indexOf("#");
    const secondHashIndex = dataString.indexOf("#", firstHashIndex + 1);

    if (secondHashIndex !== -1) {
      const remainingString = dataString.slice(secondHashIndex + 1);
      const locationDetails = remainingString.split("#").join(", ");
      return locationDetails;
    }
    return "-";
  }

  /**Update the download icon on new report download mqtt event**/
  const newDownloadNotification = useMemo(() => {
    const reportTypeString = "DeviceUpdateList";
    const data = reportUpdateStatus.find(
      (val) => val.reportType === reportTypeString
    );
    return !!data;
  }, [currentRoute, reportUpdateStatus]);

  // /**Callback : Generate CSV */
  const onCsvClick = useCallback(() => {
    let selectedPayloadLoction = "";

    if (selectedLocation.length) {
      selectedPayloadLoction = selectedLocation[selectedLocation.length - 1];
    }

    const queryParam = {
      requestedUserId: userCognitoData.username,

      filters: {
        tenant: [orgData?.TenantId],
        site: [siteData.id],
        deviceLocationHierarchy: selectedPayloadLoction,
        model: modelFilterVal,
        version: selectedVersionData,
        otaStatus: systemStatus,
      },
      sort: generateSortPayload(),

      userTimezone: moment.tz.guess(),
    };

    setIsLoading(true);
    generateDeviceUpdateCsvReport(queryParam)
      .then((response) => {
        setIsLoading(false);
        setShowDownloadModal(true);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  }, [
    selectedLocation,
    userCognitoData.username,
    orgData?.TenantId,
    siteData.id,
    modelFilterVal,
    selectedVersionData,
    systemStatus,
    generateSortPayload,
  ]);

  const handlePageChange = useCallback((item) => {
    setCurrentPage(item + 1);
  }, []);

  const valueFormatter = useCallback((data, key) => {

    if(key === "otaStatus"){
      if(data === "UpdateAvailable"){
        return t("reportFilter.chorusUpdateDeviceList.updateAvailable");
      } else if(data === "UpToDate"){
        return t("reportFilter.chorusUpdateDeviceList.systemUpToDate");
      } else if(data === "InProgress"){
        return t("reportFilter.chorusUpdateDeviceList.updateInProgress");
      }
    }

    if (data) {
      return data;
    } else {
      return "-";
    }
  }, [t]);


  return (
    <div className="bodyInner deviceListPage reportPageMain">
      {siteData?.id ? (
        <div className="bodyContainer">
          {/* Header Starts  */}
          <div className="controllesWrapper header fixSubHeader">
            <div className="left-header page-heading">
              <span className="heading-1" onClick={goBack}>
                {t("reportsHeading")}
              </span>
              <span className="heading-2">
                / {t("institutionUpdateDeviceListHeading")}
              </span>
            </div>
            <div className="right-header">
              <span className="enabledIcon header-icons">
                <button
                  className={`verticalBtn
                  ${newDownloadNotification ? "" : "hide-circle"}`}
                  onClick={() => navigate("/reports/downloads")}
                  title={t("downloads")}
                >
                  {Icons.downalodStatusIcon}
                </button>
              </span>
              <span className="disabledIcon header-icons">
                <button
                  className={"verticalBtn"}
                  disabled
                  title={t("mark_favorite")}
                >
                  {Icons.favoriteIcon}
                </button>
              </span>
              <span className="disabledIcon header-icons">
                <button
                  className="verticalBtn"
                  disabled
                  title={t("export_as_pdf")}
                >
                  {Icons.pdfIcon}
                </button>
              </span>
              <span className="header-icons">
                <button
                  className="verticalBtn"
                  onClick={onCsvClick}
                  disabled={!updateListData?.length}
                  title={t("export_as_csv")}
                >
                  {Icons.csvIcon}
                </button>
              </span>
              <span className="disabledIcon header-icons">
                <button className="verticalBtn" disabled title={t("print")}>
                  {Icons.printIcon}
                </button>
              </span>
            </div>
          </div>
          <div className="body-container-wrapper">
            {/* Header Ends  */}

            {/* Body Starts */}

            <div className="deviceUpdatesListBody">
              <div className="upperSection">
                <div className="left-section">
                  {/* {isAllSites && (
                    <div className="dropdown isAllSites siteDropdown">
                      <MultiSelectDropdown
                        dropdownOptions={siteListDetails}
                        placeholder={t("reportFilter.auditTrail.site")}
                        showCheckbox={true}
                        className="site-filter"
                        onValSelect={(selectedList, selectedItem) => {
                          updateSiteVal(selectedList);
                        }}
                        onValRemove={(selectedList, removedItem) => {
                          updateSiteVal(selectedList);
                        }}
                      />
                    </div>
                  )} */}
                </div>

                <div className="rightSection">
                  <div className="dropdown">
                    <MultiSelectDropdown
                      dropdownOptions={modelFilterOption}
                      placeholder={t(
                        "reportFilter.chorusUpdateDeviceList.model"
                      )}
                      showCheckbox={true}
                      className="model-filter"
                      onValSelect={(selectedList, selectedItem) => {
                        updateModeFilterVal(selectedList);
                      }}
                      onValRemove={(selectedList, removedItem) => {
                        updateModeFilterVal(selectedList);
                      }}
                    />
                  </div>

                  <div
                    className={
                      displayLocation.length
                        ? "locationFilterContainer selected"
                        : "locationFilterContainer"
                    }
                  >
                    <div
                      className={
                        isAllSites
                          ? "locationFilter disabled"
                          : "locationFilter"
                      }
                      onClick={() => {
                        if (!isAllSites) {
                          setIsLocationDropdownOpen(!isLocationDropdownOpen);
                        }
                      }}
                    >
                      <div className="locationIconContainer">
                        <span id="locationIcon">{Icons.locationIcon}</span>
                        <span id="locationText">
                          {displayLocation.length ? (
                            <>{displayLocation}</>
                          ) : (
                            <>
                              {t(
                                "reportFilter.chorusUpdateDeviceList.location"
                              )}
                            </>
                          )}
                        </span>
                      </div>
                      
                      {isLocationDropdownOpen ? (
                        <span id="upArrowIcon">
                          {Icons.chevronPurpleUpArrowIcon}
                        </span>
                      ) : (
                        <span id="downArrowIcon">
                          {Icons.chevronDownArrowIcon}
                        </span>
                      )}
                    </div>

                    <div>
                      {isLocationDropdownOpen && (
                        <div>
                          <div
                            className="locationDropdownWrapper reports"
                            ref={dropdownRef}
                          >
                            <div className="d-flex align-items-center justify-content-between deviceTitleAssignDiv">
                              <button
                                id="clearBtn"
                                onClick={() => {
                                  updateClearSelectedLocation();
                                }}
                              >
                                Clear
                              </button>
                              <button
                                className="verticalBtn"
                                id="applyBtn"
                                onClick={() => {
                                  updateSelectedDeviceLocation();
                                  setIsLocationDropdownOpen(false);
                                  setIsLocationFilterApplied(
                                    !isLocationFilterApplied
                                  );
                                  setIsApplyClicked(true);
                                }}
                              >
                                Apply
                              </button>
                            </div>
                            <div className="dropdownBody">
                              {locationData?.Level1
                                ? locationData.Level1.map((level1, index1) => (
                                    <div
                                      className="locationItemWrapper"
                                      key={`location_level1_${level1.PK}`}
                                    >
                                      <div
                                        className={classNames("locationItem", {
                                          active: selectedLocation?.includes(
                                            level1.PK
                                          ),
                                        })}
                                        onClick={(e) => {
                                          handleSelectLocationLevel(
                                            level1,
                                            level1?.LocationName
                                          );
                                          expandLocationLevel(e, level1.SK, false);
                                          setIsFloorDropdownOpen(
                                            !isFloorDropdownOpen
                                          );
                                        }}
                                      >
                                        <div
                                          className="deviceTitle"
                                          id={`locationItem${index1}`}
                                        >
                                          {Icons.buildingIcon}
                                          <span>{level1?.LocationName}</span>
                                        </div>
                                        {level1?.Level2 ? (
                                          <button
                                            type="button"
                                            className="verticalBtn expandCollapseBtnLocation"
                                            id="expandCollapseBtn"
                                          >
                                            {selectedLocation?.includes(
                                              level1?.PK
                                            ) ? (
                                              <>
                                                {Icons.chevronPurpleUpArrowIcon}
                                              </>
                                            ) : (
                                              <>{Icons.chevronDownArrowIcon}</>
                                            )}
                                          </button>
                                        ) : null}
                                      </div>
                                      {expandedItem.includes(level1.PK) &&
                                      level1?.Level2
                                        ? level1?.Level2.map(
                                            (level2, index2) => (
                                              <div
                                                className="locationItemWrapper"
                                                key={`location_level2_${level2.PK}`}
                                              >
                                                <div
                                                  className={classNames(
                                                    "locationItem",
                                                    {
                                                      active:
                                                        selectedLocation?.includes(
                                                          level2.PK
                                                        ),
                                                    }
                                                  )}
                                                  onClick={(e) => {
                                                    handleSelectLocationLevel(
                                                      level2,
                                                      level1?.LocationName +
                                                        "#" +
                                                        level2?.LocationName,
                                                      [level1?.PK]
                                                    );
                                                    expandLocationLevel(
                                                      e,
                                                      level2.SK,
                                                      false
                                                    );

                                                    setIsRoomDropdownOpen(
                                                      !isRoomDropdownOpen
                                                    );
                                                  }}
                                                >
                                                  <div
                                                    className="deviceTitle"
                                                    id="deviceTitle_level2"
                                                  >
                                                    {Icons.stairIcon}
                                                    <span>
                                                      {level2?.LocationName}
                                                    </span>
                                                  </div>
                                                  {level2?.Level3 ? (
                                                    <button
                                                      type="button"
                                                      className="verticalBtn"
                                                    >
                                                      {selectedLocation?.includes(
                                                        level2.PK
                                                      ) ? (
                                                        <>
                                                          {
                                                            Icons.chevronPurpleUpArrowIcon
                                                          }
                                                        </>
                                                      ) : (
                                                        <>
                                                          {
                                                            Icons.chevronDownArrowIcon
                                                          }
                                                        </>
                                                      )}
                                                    </button>
                                                  ) : null}
                                                </div>
                                                {expandedItem.includes(
                                                  level2.PK
                                                ) && level2?.Level3
                                                  ? level2?.Level3.map(
                                                      (level3, index3) => (
                                                        <div className="locationItemWrapper">
                                                          <div
                                                            className={classNames(
                                                              "locationItem",
                                                              {
                                                                active:
                                                                  selectedLocation?.includes(
                                                                    level3.PK
                                                                  ),
                                                              }
                                                            )}
                                                            onClick={() => {
                                                              handleSelectLocationLevel(
                                                                level3,
                                                                level1?.LocationName +
                                                                  "#" +
                                                                  level2?.LocationName +
                                                                  "#" +
                                                                  level3?.LocationName,
                                                                [
                                                                  level1?.PK,
                                                                  level2?.PK,
                                                                ]
                                                              );
                                                            }}
                                                          >
                                                            <div
                                                              className="deviceTitle"
                                                              id="deviceTitle_level3"
                                                            >
                                                              {Icons.roomIcon}
                                                              <span>
                                                                {
                                                                  level3?.LocationName
                                                                }
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )
                                                    )
                                                  : null}
                                              </div>
                                            )
                                          )
                                        : null}
                                    </div>
                                  ))
                                : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="dropdown">
                    <MultiSelectDropdown
                      dropdownOptions={versionListOption}
                      placeholder={t(
                        "reportFilter.chorusUpdateDeviceList.version"
                      )}
                      showCheckbox={true}
                      className="version-filter"
                      onValSelect={(selectedList, selectedItem) => {
                        updateVersionList(selectedList);
                      }}
                      onValRemove={(selectedList, removedItem) => {
                        updateVersionList(selectedList);
                      }}
                    />
                  </div>

                  <div className="dropdown">
                    <MultiSelectDropdown
                      dropdownOptions={systemStatusOption}
                      placeholder={t(
                        "reportFilter.chorusUpdateDeviceList.systemStatus"
                      )}
                      showCheckbox={true}
                      className="system-status-filter"
                      onValSelect={(selectedList, selectedItem) => {
                        updateSystemStatus(selectedList);
                      }}
                      onValRemove={(selectedList, removedItem) => {
                        updateSystemStatus(selectedList);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="data-container">
                <table className="table deviceUpdateTable">
                  <thead>
                    <tr>
                      {isAllSites ? (
                        <th id="site">{t(`tableHeading.chorusUpdateDeviceList.site`)}</th>
                      ) : (
                        <></>
                      )}
                      <th id="deviceNameheader">
                        <div className="headerSortContainer" id="deviceName">
                          {t(`tableHeading.chorusUpdateDeviceList.deviceName`)}
                          <div
                            className="sortIconContainer"
                            title={
                              transformedSortConfigs?.deviceName
                                ? transformedSortConfigs?.deviceName
                                : "No Sort"
                            }
                          >
                            <span
                              className={getSortClass(
                                "deviceName",
                                "ascending"
                              )}
                              id="ascbutton"
                              onClick={() =>
                                requestSort("deviceName", "ascending")
                              }
                            >
                              {Icons.upArrowIcon}
                            </span>
                            <span
                              className={getSortClass(
                                "deviceName",
                                "descending"
                              )}
                              onClick={() =>
                                requestSort("deviceName", "descending")
                              }
                            >
                              {Icons.downArrowIcon}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th id="deviceUDI">
                        {t(`tableHeading.chorusUpdateDeviceList.deviceUDI`)}
                      </th>
                      <th id="modelheader">
                        {t(`tableHeading.chorusUpdateDeviceList.model`)}
                      </th>
                      <th>
                        <div className="headerSortContainer" id="location">
                          {t(`tableHeading.chorusUpdateDeviceList.location`)}

                          <div
                            className="sortIconContainer"
                            title={
                              transformedSortConfigs?.deviceLocationHierarchy
                                ? transformedSortConfigs?.deviceLocationHierarchy
                                : "No Sort"
                            }
                          >
                            <span
                              className={getSortClass(
                                "deviceLocationHierarchy",
                                "ascending"
                              )}
                              id="ascbutton"
                              onClick={() =>
                                requestSort(
                                  "deviceLocationHierarchy",
                                  "ascending"
                                )
                              }
                            >
                              {Icons.upArrowIcon}
                            </span>
                            <span
                              className={getSortClass(
                                "deviceLocationHierarchy",
                                "descending"
                              )}
                              onClick={() =>
                                requestSort(
                                  "deviceLocationHierarchy",
                                  "descending"
                                )
                              }
                            >
                              {Icons.downArrowIcon}
                            </span>
                          </div>
                        </div>
                      </th>
                      <th id="currentVersion">
                        {t(
                          `tableHeading.chorusUpdateDeviceList.currentVersion`
                        )}
                      </th>
                      <th id="systemStatus">
                        {t(`tableHeading.chorusUpdateDeviceList.systemStatus`)}
                      </th>
                      <th id="lastUpdatedBy">
                        {t(`tableHeading.chorusUpdateDeviceList.lastUpdatedBy`)}
                      </th>
                      <th id="lastUpdatedOn">
                        {t(`tableHeading.chorusUpdateDeviceList.lastUpdatedOn`)}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {updateListData?.length ? (
                      <>
                        {updateListData?.map((data, i) => {
                          return (
                            <tr key={`${i + 1}`}>
                              <td>{valueFormatter(data?.deviceName)}</td>
                              <td>{valueFormatter(data?.deviceUdi)}</td>
                              <td>{valueFormatter(data?.deviceModel)}</td>
                              <td>
                                {valueFormatter(
                                  extractLocationDetails(data?.deviceLocation)
                                )}
                              </td>
                              <td>
                                {data?.currentVersion ? (
                                  <>{extractVersion(data?.currentVersion)}</>
                                ) : (
                                  <>-</>
                                )}
                              </td>
                              <td
                                id={
                                  (data?.otaStatus === "UpdateAvailable" || data?.otaStatus === "InProgress")
                                    ? "clickable"
                                    : ""
                                }
                                onClick={() => {
                                  if (data?.otaStatus === "UpdateAvailable" || data?.otaStatus === "InProgress") {
                                    setSelectedDevice(data?.deviceUdi);
                                    setIsOTAModalOpen(true);
                                  }
                                }}
                              >
                                {valueFormatter(data?.otaStatus,"otaStatus")}
                              </td>
                              <td>{valueFormatter(data?.otaUpdatedBy)}</td>
                              <td>
                                {data?.otaUpdatedOn ? (
                                  <>{formatDate(data?.otaUpdatedOn, false)}</>
                                ) : (
                                  <>-</>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <tr>
                        <td colSpan="40" className="empty-screen-td">
                          <div className="empty-screen-wrapper">
                            {emptyMsg.title !== "" && (
                              <EmptyScreen
                                img={Icons.emptyScreenReports}
                                small={true}
                                title={t("no_data_to_display")}
                                desc={emptyMsg}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Body Ends */}

            {/* Footer Starts  */}

            {updateListData?.length ? (
              <div className="bodyFooter footerFixed">
                {/* Pagination */}

                <Pagination
                  currentPage={currentPage - 1}
                  totalPages={pageTotalCount}
                  pageCallBack={handlePageChange}
                />

                <div className="footer-time">
                  <span>
                    {t("reportGeneratedOn", {
                      time: formatAMPM(refreshTime, false),
                    })}
                  </span>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          {/* Footer Ends  */}
          {isDeviceDetailsLoading && <LoadingSpinner />}
          {isLoading && <LoadingSpinner />}
        </div>
      ) : (
        <></>
      )}

      {isOTAModalOpen && (
        <OTAUpdates
          closeModal={() => {
            setIsOTAModalOpen(false);
            // handleRefreshBtn();
          }}
          deviceData={selectedDeviceData}
          systemUpToDate={selectedDeviceData?.otaStatus === "UpToDate"}
          otaStatus={selectedDeviceData?.otaStatus}
          // refreshDevicePage={handleRefreshBtn}
        />
      )}

      {/* Modal Section starts */}
      <ModalComponent
        idName="csv-download-modal"
        isOpen={showDownloadModal}
        onCloseModal={() => setShowDownloadModal(false)}
        onConfirm={() => navigate("/reports/downloads")}
        descriptionText={t("downloadModalMsg")}
        primaryBtnText={t("goToDownload")}
        primaryTextIcon={Icons.maximizeIcon}
        secondaryBtnText={t("close")}
        needConfirmation={true}
      ></ModalComponent>
      {/* Modal Section Ends */}
    </div>
  );
};

export default DeviceUpdateList;
